import { render, staticRenderFns } from "./seccionBuscar.vue?vue&type=template&id=84b1f298"
import script from "./seccionBuscar.vue?vue&type=script&lang=js"
export * from "./seccionBuscar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports